/**
 * Folha de ação curta (iniciar, pausar, cancelar, confirmar salto): sobe do
 * rodapé no celular, no alcance do polegar, e vira modal centralizado no
 * desktop. O ERP não tinha bottom sheet; este é local da Área do PCP até um
 * segundo uso justificar levá-lo para `components/`.
 */
import React, { useEffect, useRef } from "react";
import styled from "styled-components";

import { SCRIM, tabletAcima } from "../styles";

const Fundo = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1200;
  background: ${SCRIM};
  display: flex;
  align-items: flex-end;
  justify-content: center;

  @media ${tabletAcima} {
    align-items: center;
    padding: 16px;
  }
`;

const Caixa = styled.div`
  width: 100%;
  max-height: 92vh;
  overflow-y: auto;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 20px 20px 0 0;
  padding: 18px 16px calc(16px + var(--safe-area-bottom, 0px));
  display: flex;
  flex-direction: column;
  gap: 14px;
  box-shadow: var(--shadow-3);

  @media ${tabletAcima} {
    width: min(92vw, 460px);
    border-radius: 16px;
    padding: 20px 22px;
  }

  h2 {
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    color: var(--ink);
  }

  .sub {
    margin: -8px 0 0;
    font-size: 13px;
    color: var(--ink-2);
  }

  /* Ações lado a lado, à direita, no tamanho do texto — nunca botão
     esticado na largura toda. */
  .acoes {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 8px;
  }
`;

export default function Folha({ aberta, titulo, subtitulo, onFechar, children, acoes, rotulo }) {
  const caixa = useRef(null);

  useEffect(() => {
    if (!aberta) return undefined;
    const primeiro = caixa.current?.querySelector("input, textarea, select, button");
    primeiro?.focus();
    const aoTeclar = (e) => {
      if (e.key === "Escape") onFechar?.();
    };
    document.addEventListener("keydown", aoTeclar);
    return () => document.removeEventListener("keydown", aoTeclar);
  }, [aberta, onFechar]);

  if (!aberta) return null;
  return (
    <Fundo
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onFechar?.();
      }}
    >
      <Caixa ref={caixa} role="dialog" aria-modal="true" aria-label={rotulo || titulo}>
        {titulo ? <h2>{titulo}</h2> : null}
        {subtitulo ? <p className="sub">{subtitulo}</p> : null}
        {children}
        {acoes ? <div className="acoes">{acoes}</div> : null}
      </Caixa>
    </Fundo>
  );
}
